<div class="search-filters-row-container">
    <div
        *ngFor="let param of searchParams; let i = index"
        class="search-filter"
        #child
        [ngStyle]="{ width: filterWidth }"
    >
        <!-- string number-->
        <mat-form-field
            *ngIf="SearchParamType.number === param.property.type || SearchParamType.string === param.property.type"
            appearance="outline"
            class="se-form-field"
        >
            <mat-label>{{ labelTranslationKeyToString(param.labelTranslationKey) | translate }}</mat-label>
            <input
                (change)="onFilterChange(param.property.name, i)"
                [(ngModel)]="param.property.value"
                [autofocus]="!!param.layout?.autofocus"
                [disabled]="!!param.layout?.disabled"
                [placeholder]="labelTranslationKeyToString(param.labelTranslationKey) | translate"
                [type]="param.property.type"
                autocomplete="off"
                matInput
                se-autofocus
            />
        </mat-form-field>

        <!-- combo combomulti-->
        <mat-form-field
            *ngIf="
                SearchParamType.select === param.property.type || SearchParamType.multiSelect === param.property.type
            "
            appearance="outline"
            class="se-form-field"
        >
            <mat-label *ngIf="!param.property.itemsSourceInfo?.dataLoading"
                >{{ labelTranslationKeyToString(param.labelTranslationKey) | translate }}
            </mat-label>
            <mat-label *ngIf="param.property.itemsSourceInfo?.dataLoading">
                <div class="mat-select-waiting-spinner-container">
                    <mat-spinner class="spinner" diameter="16"></mat-spinner>
                    <span style="margin-left: 5px">{{ "Loading" | translate }}</span>
                </div>
            </mat-label>
            <mat-select
                (selectionChange)="onFilterChange(param.property.name, i)"
                [(ngModel)]="param.property.value"
                [autofocus]="!!param.layout?.autofocus"
                [disabled]="!!param.layout?.disabled"
                [multiple]="SearchParamType.multiSelect === param.property.type"
                [name]="param.property.name"
                [placeholder]="labelTranslationKeyToString(param.labelTranslationKey) | translate"
                [typeaheadDebounceInterval]="500"
                se-autofocus
            >
                <mat-option
                    *ngFor="let option of param.property.itemsSourceInfo?.data ?? []"
                    [matTooltipDisabled]="!param.property.itemsSourceInfo?.enableTooltip"
                    [matTooltip]="'' + option[param.property.itemsSourceInfo?.displayProperty ?? '']"
                    [value]="option.guid ?? option.id"
                    matTooltipPosition="above"
                    matTooltipShowDelay="1000"
                >
                    {{ option[param.property.itemsSourceInfo?.displayProperty ?? ""] }}
                </mat-option>
            </mat-select>
            <button
                (click)="resetComboSelectedValue(param.property.name, i, $event)"
                *ngIf="param.property.itemsSourceInfo"
                class="se-button-no-ripple"
                mat-icon-button
                matSuffix
                tabIndex="-1"
                type="button"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <!-- combofilter combofiltermulti-->
        <mat-form-field
            *ngIf="
                SearchParamType.filterSelect === param.property.type ||
                SearchParamType.filterMultiSelect === param.property.type
            "
            appearance="outline"
            class="se-form-field"
        >
            <mat-label *ngIf="!!param.property.itemsSourceInfo?.dataLoading">
                <div class="mat-select-waiting-spinner-container">
                    <mat-spinner class="spinner" diameter="16"></mat-spinner>
                    <span style="margin-left: 5px">{{ "Loading" | translate }}</span>
                </div>
            </mat-label>
            <mat-label *ngIf="!param.property.itemsSourceInfo?.dataLoading"
                >{{ labelTranslationKeyToString(param.labelTranslationKey) | translate }}
            </mat-label>
            <mat-select
                (selectionChange)="onFilterChange(param.property.name, i)"
                [(ngModel)]="param.property.value"
                [autofocus]="!!param.layout?.autofocus"
                [disabled]="!!param.layout?.disabled"
                [multiple]="SearchParamType.filterMultiSelect === param.property.type"
                [name]="param.property.name"
                [placeholder]="labelTranslationKeyToString(param.labelTranslationKey) | translate"
                [typeaheadDebounceInterval]="500"
                se-autofocus
            >
                <mat-option>
                    <ngx-mat-select-search
                        (ngModelChange)="onSelectFiltering(param.property.name, i, $event)"
                        [name]="param.property.name + '__filter'"
                        [noEntriesFoundLabel]="'NoResults' | translate"
                        [placeholderLabel]="'Search' | translate"
                        ngModel
                    >
                    </ngx-mat-select-search>
                </mat-option>

                <ng-container *ngIf="!param.property.itemsSourceInfo?.dataLoading">
                    <mat-option
                        *ngFor="let option of param.property.itemsSourceInfo?.data ?? []"
                        [matTooltipDisabled]="!param.property.itemsSourceInfo?.enableTooltip"
                        [matTooltip]="'' + option[param.property.itemsSourceInfo?.displayProperty ?? '']"
                        [value]="option.guid ?? option.id"
                        matTooltipPosition="right"
                        matTooltipShowDelay="1000"
                    >
                        {{ option[param.property.itemsSourceInfo?.displayProperty ?? ""] }}
                    </mat-option>
                </ng-container>
            </mat-select>
            <button
                (click)="resetComboSelectedValue(param.property.name, i, $event)"
                *ngIf="param.property.itemsSourceInfo"
                class="se-button-no-ripple"
                mat-icon-button
                matSuffix
                tabIndex="-1"
                type="button"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <se-date-range
            *ngIf="SearchParamType.fromTo === param.property.type"
            (dataRangeChange)="onFilterChange(param.property.name, i)"
            (keydown.enter)="onEnterKeyDown($event)"
            [autofocus]="!!param.layout?.autofocus"
            [disabled]="!!param.layout?.disabled"
            [(ngModel)]="param.property.value"
            [name]="param.property.name"
            [label]="labelTranslationKeyToFromToLabel(param.labelTranslationKey)"
            [id]="param.property.name"
        ></se-date-range>

        <!--  date -->
        <mat-form-field
            *ngIf="SearchParamType.date === param.property.type"
            appearance="outline"
            class="se-flex-1-1-auto se-form-field"
        >
            <mat-label>{{ labelTranslationKeyToString(param.labelTranslationKey) | translate }}</mat-label>
            <input
                (dateChange)="onFilterChange(param.property.name, i)"
                (keydown.enter)="onEnterKeyDown($event)"
                (keydown.space)="$event.preventDefault()"
                [(ngModel)]="param.property.value"
                [autofocus]="!!param.layout?.autofocus"
                [disabled]="!!param.layout?.disabled"
                [id]="param.property.name"
                [matDatepicker]="searchDate"
                [name]="param.property.name"
                [placeholder]="labelTranslationKeyToString(param.labelTranslationKey) | translate"
                class="se-form-field-input"
                matInput
                se-autofocus
            />
            <mat-datepicker-toggle
                [for]="searchDate"
                class="se-mat-datepicker-toggle se-button-no-ripple"
                matSuffix
            ></mat-datepicker-toggle>
            <mat-datepicker #searchDate type="date"></mat-datepicker>
        </mat-form-field>

        <!-- Boolean - Check -->
        <div
            *ngIf="SearchParamType.boolean === param.property.type"
            class="se-flex-1-1-auto"
            style="flex-direction: column"
        >
            <div class="se-flex-1"></div>
            <mat-checkbox
                (change)="onFilterChange(param.property.name, i)"
                [(ngModel)]="param.property.value"
                [disabled]="!!param.layout?.disabled"
                [id]="param.property.name"
                [name]="param.property.name"
                labelPosition="after"
            >
                {{ labelTranslationKeyToString(param.labelTranslationKey) | translate }}
            </mat-checkbox>
            <div style="flex: 1"></div>
        </div>
    </div>
</div>
